<div class="ck__content ck-content" [innerHTML]="content | safeHtml"></div>

<div class="lightbox" *ngIf="lightboxSrc" (click)="closeLightbox()">
  <img [src]="lightboxSrc" class="lightbox__image" />
</div>
